<template>
  <div class="content-bd" :class="ClassLayout">
    <div class="content-left">
      <section class="practice" v-reveal>
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">工作经验</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <!-- 智煊芯微 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <div class="item-hd-box">
                <div class="item-hd-box-img" :class="{ 'is-open': !BoxList[5].class }" role="button" tabindex="0"
                  :aria-expanded="BoxList[5].class ? 'false' : 'true'" :title="BoxList[5].class ? '展开' : '收起'"
                  @click="showBox(5)" @keydown.enter.prevent="showBox(5)" @keydown.space.prevent="showBox(5)">
                  <img :src="BoxList[5].imgUrl" alt="">
                </div>
                <div>
                  <h3 class="item-name">湖南智煊芯微科技有限公司</h3>
                  <span class="item-time">2025.01 – 至今</span>
                </div>
              </div>
              <a class="btn item-more">全栈工程师 · AI 平台 / 智能体</a>
            </header>

            <transition name="fold" @enter="foldEnter" @after-enter="foldAfterEnter" @leave="foldLeave"
              @after-leave="foldAfterLeave">
              <ol v-show="!BoxList[5].class" class="item-project">
              <li class="project-1 is-featured" id="lad-v2">
                <h3 class="project-name">
                  LAD-v2 / LAD-Witglow · 电子设计领域智能体平台
                  <span class="flag flag--core">核心项目</span>
                </h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          面向集成电路前端设计的私域智能体平台：把自然语言需求与领域文档转成 SysML v2 形式化模型，由多智能体规划并调用 EDA
                          工具链生成 RTL/UVM 与工程交付物，经 L1–L3 验证后把结果回写知识图谱，形成「需求 → 建模 → 生成 → 验证 → 记忆」的闭环。
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【我的工作】</h3>
                        <ul class="section-content">
                          <li>参与五层架构（表现层 / 业务逻辑 / 服务层 / 数据层 / 基础设施）的产品化落地，负责智能体工作台前端：项目进度、流程总览、任务分布、质量门禁与 CPU / 显存资源监控。</li>
                          <li>参与感知 / 规划 / 执行 / 验证 / 专家五类智能体的编排与会话管理，对接多 LLM 矩阵（需求、架构、建模、IC、验证、FPGA、HIL）的统一调度与工具调用协议。</li>
                          <li>参与 SysML v2 自动建模链路：多图 Agent 并行生成 → 语义融合与冲突消解 → XMI 2.5 导出，处理需求图、用例图、BDD/IBD、状态机之间的跨图一致性。</li>
                          <li>参与代码生成流水线（解析 → AST → 语义校验 → 模板匹配 → 实例化 → 编译验证）与验证金字塔 L1 静态 / L2 形式化 / L3 仿真 三级质量门禁。</li>
                          <li>参与 KAG 知识图谱与 MemEvolve 记忆演化：把验证失败样本与修复轨迹回写知识库，让同类错误在后续任务中被提前拦截。</li>
                          <li>落实私域安全约束：数据不出域、本地模型中心、调用审计与权限隔离，满足芯片设计数据的合规要求。</li>
                        </ul>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【参与测试模型】</h3>
                        <ul class="section-content">
                          <li>参与 LAD-Witglow 等领域模型的企业级评估，建立五维评估框架，综合得分 81.1 / 100（有条件就绪）；RTL 代码生成用例达 9.07 / 10（S 级优秀）。</li>
                          <li>参与 qwen3.5:9b、stm32-KZ、ST-KZ 三款本地模型的横向评测，按统一用例对比各模型在领域任务上的表现。</li>
                          <li>参与 STM32 CoT V3 模型 Function Calling（5 个内置工具）与 MCP 工具链（77 个工具）的集成验证，覆盖工具调用正确性与端到端任务闭环。</li>
                        </ul>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【收集训练数据集】</h3>
                        <ul class="section-content">
                          <li>参与模型训练数据集的收集、清洗与整理，支撑单模型训练数据集建设达 112.6 万条。</li>
                          <li>其中 Function Calling 指令数据 7,627 条，覆盖工具调用指令的构造、校验与入库。</li>
                        </ul>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【数据集 3D 知识图谱】</h3>
                        <p class="item-project-des">
                          自研 DocNode Flow，把数据集从「文件目录」升级为「知识网络」：以 3D 力导向图组织 110 篇领域文档与 799 条关联连线，
                          覆盖 PDK、SystemRDL、UVM / SVA、AI-ML 架构等知识簇，让结构关系在同一视图里被看见。
                        </p>
                        <ul class="section-content">
                          <li>3D 力导向布局渲染节点与连线，支持拖拽旋转、方向键飞行、滚轮缩放、右键 / Shift 平移、单击聚焦、双击展开与 Esc 取消。</li>
                          <li>标签图例联动过滤：Tags / sparks / PDK / ti / 通用等标签直接展示节点数量，按标签分组并支持组内着色分级，节点标签随缩放级别显隐。</li>
                          <li>顶部搜索按标签 / 标签路径定位文档，为评测用例抽样与知识溯源提供可视化入口。</li>
                        </ul>
                      </div>
                      <div class="tag-row">
                        <span>多智能体编排</span>
                        <span>SysML v2</span>
                        <span>XMI 2.5</span>
                        <span>KAG / RAG</span>
                        <span>工具调用</span>
                        <span>模型评测</span>
                        <span>训练数据集</span>
                        <span>3D 知识图谱</span>
                        <span>私域部署</span>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>

              <li class="project-1 is-featured" id="cgra">
                <h3 class="project-name">
                  <a href="https://cgra.witglow.cn/" target="_blank" rel="noopener"
                    title="点击进入 → CGRA 可视化仿真 IDE">CGRA 可视化仿真 IDE · cgra.witglow.cn</a>
                  <span class="flag flag--live"><i class="flag-dot" aria-hidden="true"></i>在线 Demo</span>
                </h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          面向粗粒度可重构阵列（CGRA）的浏览器端可视化仿真 IDE，覆盖架构搭建、算法映射、数据流仿真、调试分析与 FPGA 上板联调，
                          让阵列结构、算子映射与运行数据在同一界面里被看见。
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【我的工作】</h3>
                        <ul class="section-content">
                          <li>阵列可视化与架构设计：N×M 网格配置，主核 / 子核 / 枢纽 / 管理器 / 统一总线组件拖拽建模，实时展示拓扑连接与单元属性。</li>
                          <li>算法映射器：算子库拖拽映射到 PE、资源冲突检测、映射方案保存 / 加载与配置生成。</li>
                          <li>数据流仿真：数据 Token 注入、单步 / 连续 / 暂停 / 重置、周期计数，实时呈现路由路径、PE 利用率与运行日志。</li>
                          <li>调试与性能分析：断点、单步进入 / 跳过、寄存器与局部存储器、指令历史，以及吞吐率、平均延迟、能效比统计。</li>
                          <li>软硬件联动：串口连接 FPGA 开发板，摄像头实时视频流（灰度 / 轮廓）经 PE 处理；WebSocket 中继桥支持批量数据回放与丢包统计。</li>
                          <li>支持架构属性检查与 RTL 代码导出，打通「设计 → 仿真 → 验证 → 上板」链路。</li>
                        </ul>
                        <div class="tag-row">
                          <span>CGRA</span>
                          <span>PE 阵列可视化</span>
                          <span>数据流仿真</span>
                          <span>WebSocket</span>
                          <span>FPGA 联调</span>
                          <span>RTL 导出</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              </ol>
            </transition>
          </div>

          <!-- 进芯电子 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <div class="item-hd-box">
                <div class="item-hd-box-img" :class="{ 'is-open': !BoxList[4].class }" role="button" tabindex="0"
                  :aria-expanded="BoxList[4].class ? 'false' : 'true'" :title="BoxList[4].class ? '展开' : '收起'"
                  @click="showBox(4)" @keydown.enter.prevent="showBox(4)" @keydown.space.prevent="showBox(4)">
                  <img :src="BoxList[4].imgUrl" alt="">
                </div>
                <div>
                  <h3 class="item-name">湖南进芯电子科技有限公司</h3>
                  <span class="item-time">2022.09 – 2025.01</span>
                </div>
              </div>
              <a class="btn item-more">软件工程师</a>
            </header>
            <transition name="fold" @enter="foldEnter" @after-enter="foldAfterEnter" @leave="foldLeave"
              @after-leave="foldAfterLeave">
              <ol v-show="!BoxList[4].class" class="item-project">
              <li class="project-1">
                <h3 class="project-name">软件前端开发</h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <a href="https://webide.hotchip.top" target="_blank" rel="noopener"
                        title="点击进入 → WEB-IDE 网页编辑器">
                        <h3 class="project-name-2">WEB-IDE 网页编辑器（软著登记号 2024SR2055146）</h3>
                      </a>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>仿 VS Code 完成编辑器界面开发</li>
                          <li>集成 WIFI-JTAG 调试功能与界面交互可视化开发</li>
                          <li>集成编译器工具链，为 WIFI-JTAG 提供数据支持</li>
                          <li>集成 WIFI-JTAG-ADV 蓝牙适配 WIFI 的芯片配置可视化开发</li>
                          <li>代码节点 AST 可视化开发</li>
                          <li>打包相关插件为 exe，在官网提供下载</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li class="project-2">
                    <div class="item-bd">
                      <a href="https://wifi.hotchip.top" target="_blank" rel="noopener"
                        title="点击进入 → WIFI-JTAG-ADV 蓝牙适配">
                        <h3 class="project-name-2">WIFI-JTAG-ADV 蓝牙适配</h3>
                      </a>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>完成基础框架搭建（各项浏览器支持测试）安卓 / PWA</li>
                          <li>通过浏览器蓝牙能力对 WIFI-JTAG 芯片进行 WIFI 配置</li>
                          <li>对 WIFI-JTAG 返回 IP 做可视化处理，展示对应芯片 ID</li>
                          <li>负责项目线上部署</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              <li class="project-1">
                <h3 class="project-name">软件后端开发</h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">arch-studio 开发</h3>
                      <div class="div-item">
                        <h3 class="project-des">【工作职责】</h3>
                        <ul class="section-content">
                          <li>完成项目基本界面</li>
                          <li>配合后端实现 SystemRDL 数据自动生成 JSON 并保存</li>
                          <li>基于界面交互数据开发 Spring Boot 接口，将 SystemRDL 各层含义的 JSON 数据落库</li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              </ol>
            </transition>
          </div>
        </div>
      </section>

      <!-- 开源项目 -->
      <section class="project nopdf" v-reveal>
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">开源项目</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <p class="item-project-des">以下是我的开源项目与学习总结，细节请点击链接查看（其他项目开发中，尚未开源，敬请期待）。</p>

          <div class="item" v-reveal>
            <header class="item-hd">博客 / Gitee</header>
            <div class="item-bd">
              <ul>
                <li><a href="https://blog.csdn.net/qq_64929177?type=blog" target="_blank" rel="noopener">CSDN 博客</a></li>
                <li><a href="https://gitee.com/chengcurry30" target="_blank" rel="noopener">Gitee</a></li>
                <li><a href="http://andysama.work" target="_blank" rel="noopener">个人网站主页</a></li>
              </ul>
            </div>
          </div>

          <div class="item" v-reveal>
            <header class="item-hd">WEB 前端</header>
            <div class="item-bd">
              <ul>
                <li><a href="https://gitee.com/chengcurry30/frontend-vue2" target="_blank" rel="noopener">AI 开放社区</a> · 集成了很多 AI 工具</li>
                <li><a href="https://gitee.com/chengcurry30/study-online" target="_blank" rel="noopener">微服务课程售卖系统</a> · 使用微服务技术打造的在线课程售卖系统</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="content-right">
      <section class="skill" v-reveal>
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">技能</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <!-- AI 平台 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">AI 平台 / 智能体</span>
              <a class="btn item-more">核心</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟悉 LLM 应用工程化：多智能体编排、工具调用与长任务拆解，能把业务流程拆成可执行的 Agent 工作流</li>
                <li>具备领域模型评测与数据集建设经验：五维评估框架、多模型横向评测，以及 112.6 万条训练数据集的收集与清洗</li>
                <li>了解 KAG / RAG 知识增强与知识图谱构建，理解「验证结果回写知识库」的闭环设计</li>
                <li>了解 SysML v2 与形式化需求建模，能把领域文档转成可验证的结构化约束</li>
                <li>具备 IC 前端设计域认知：RTL、UVM、综合、仿真、FPGA / HIL 的基本流程与工具边界</li>
              </ul>
            </div>
          </div>

          <!-- 前端可视化 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">前端 / 可视化</span>
              <a class="btn item-more">熟练</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>Vue 2 / Vue 3 全家桶（Vue-Router、Vuex），React 基础，ElementUI / Ant Design 组件库</li>
                <li>复杂交互与可视化：阵列拓扑、数据流、流程编排类界面，SVG / Canvas 渲染与渲染性能优化</li>
                <li>WebSocket 实时数据流、大列表渲染、组件化拆分与状态管理</li>
                <li>掌握 HTML / CSS / SCSS，能独立完成响应式布局与动效实现</li>
              </ul>
            </div>
          </div>

          <!-- WEB 后端 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">WEB 后端开发</span>
              <a class="btn item-more">熟练</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟练使用 Spring Boot、Spring MVC 等主流框架，熟悉 RESTful 风格 API 设计</li>
                <li>熟悉 API 开发流程，熟练使用 RabbitMQ、Kafka 等消息中间件，有实际项目使用经验</li>
                <li>了解 Spring Cloud 微服务化与服务治理</li>
                <li>熟练使用 Redis、MongoDB 等非关系型数据库，有实际项目使用经验</li>
              </ul>
            </div>
          </div>

          <!-- 服务器 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">服务器 / 架构</span>
              <a class="btn item-more">熟练</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟练使用 Nginx、Tomcat、Apache 服务器</li>
                <li>熟练在服务器搭建与使用 MySQL、Redis、RabbitMQ、Nacos、XXL-JOB、Elasticsearch</li>
                <li>熟练使用 CentOS 云服务器，掌握线上环境部署</li>
                <li>了解 Docker 使用及应用部署，熟悉微服务、高并发、高可用集群架构</li>
                <li>熟练使用 Git、GitHub、Gitee、Gradle、Maven</li>
              </ul>
            </div>
          </div>

          <!-- 数据库 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">数据库</span>
              <a class="btn item-more">熟练</a>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>熟悉关系型数据库，熟练使用 MySQL</li>
                <li>熟悉非关系型数据库，熟练使用 Redis</li>
                <li>了解 MyBatis、JDBC 等数据库操作框架</li>
              </ul>
            </div>
          </div>

          <!-- 独立开发 -->
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">独立开发</span>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>有独自主导并负责的项目开发经验，可独立完成从设计到上线</li>
                <li>良好的编码习惯与编程思想，学习能力强，对新技术保持热情</li>
                <li>工作稳定性高，有一定项目管理经验</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      

      <section class="practice" v-reveal>
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">项目经验</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <div class="item" v-reveal>
            <header class="item-hd">
              <div class="item-hd-box">
                <div class="item-hd-box-img" :class="{ 'is-open': !BoxList[0].class }" role="button" tabindex="0"
                  :aria-expanded="BoxList[0].class ? 'false' : 'true'" :title="BoxList[0].class ? '展开' : '收起'"
                  @click="showBox(0)" @keydown.enter.prevent="showBox(0)" @keydown.space.prevent="showBox(0)">
                  <img :src="BoxList[0].imgUrl" alt="">
                </div>
                <div>
                  <h3 class="item-name">AI 开放社区（已参加比赛并获奖）</h3>
                  <span class="item-time">2022.01 – 2024.06</span>
                </div>
              </div>
              <a class="btn item-more" href="http://andysama.work" target="_blank" rel="noopener"
                title="点击查看 → AI 开放社区首页">主要负责人（独立开发）</a>
            </header>
            <transition name="fold" @enter="foldEnter" @after-enter="foldAfterEnter" @leave="foldLeave"
              @after-leave="foldAfterLeave">
              <ol v-show="!BoxList[0].class" class="item-project">
              <li class="project-1">
                <h3 class="project-name">
                  <a href="https://andysama.work" target="_blank" rel="noopener"
                    title="点击进入 → AI 开放社区首页">项目地址 https://andysama.work</a>
                </h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <div class="div-item">
                        <h3 class="project-des">【项目简介】</h3>
                        <p class="item-project-des">
                          AI 开放社区通过提供一个集成 AI 产品的平台，帮助用户快速找到最适合他们需求的 AI 解决方案，
                          并通过社区指引正确使用这些产品。项目主要关注两个方向：<br>
                          一是让 AI 服务于用户的产品，例如 ChatGPT、AI 虚拟数字人和 AI 助手；<br>
                          二是用户与 AI 共同创造的领域，如 AI 绘画、AI 音乐创作、AI 生成 PPT 和文档等。
                        </p>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【主要技术栈】</h3>
                        <ul class="section-content">
                          <li>使用 Vue.js + ElementUI 绘制前端基础页面，结合 Markdown 插件，通过身份校验动态拼接路由</li>
                          <li>Spring Boot 搭配 Spring Cloud，使用 JWT 进行身份校验，结合阿里云 Java SDK 接入语音输入、人脸识别、虚拟数字人</li>
                          <li>对常用数据做缓存处理（Redis），并对撮合引擎系统进行架构设计</li>
                          <li>Nacos 动态配置服务：在所有环境中以集中、动态的方式管理服务配置，更新配置时无需重新部署</li>
                          <li>Elasticsearch 承接高并发检索，提高站点响应速度；MinIO 负责文件存储与分发，分片上传处理大文件</li>
                          <li>Kibana 作为 Elasticsearch 的可视化工具；XXL-JOB 负责任务调度，节省人力</li>
                        </ul>
                      </div>
                      <div class="div-item">
                        <h3 class="project-des">【项目部署】</h3>
                        <ul class="section-content">
                          <li>主要采用腾讯云轻量级服务器进行项目部署</li>
                          <li>前端 Vue.js 打包后使用 Nginx 做端口转发</li>
                          <li>后端采用 Docker 打包部署，并用 Docker 搭建 Nacos、MinIO、Elasticsearch、Kibana、Redis、XXL-JOB 等基础环境</li>
                        </ul>
                      </div>
                      <div class="tag-row">
                        <span>Vue.js</span>
                        <span>Spring Cloud</span>
                        <span>Redis</span>
                        <span>Elasticsearch</span>
                        <span>Docker</span>
                        <span>Nginx</span>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              <li class="project-1">
                <h3 class="project-name">
                  <a href="http://andysama.work:8555/" target="_blank" rel="noopener"
                    title="点击进入 → 数字货币钱包">后续升级课程内容</a>
                </h3>
                <ol>
                  <li class="project-2">
                    <div class="item-bd">
                      <h3 class="project-name-2">后续升级</h3>
                      <div class="div-item">
                        <h3 class="project-des">【升级内容】</h3>
                        <p class="item-project-des">
                          后续使用微服务技术进行升级：Elasticsearch 提供高并发检索，MinIO 负责对象存储，Nacos 统一配置管理，
                          XXL-JOB 管理线上任务，降低环境切换与发布成本。
                        </p>
                      </div>
                    </div>
                  </li>
                </ol>
              </li>
              </ol>
            </transition>
          </div>
        </div>
      </section>

      <!-- 奖项/证书 -->
      <section class="prize" v-reveal>
        <header class="section-hd">
          <span class="section-title-l"></span>
          <h2 class="section-title">奖项 / 证书</h2>
          <span class="section-title-r"></span>
        </header>
        <div class="section-bd">
          <div class="item" v-reveal>
            <header class="item-hd">
              <span class="item-time">获奖经历</span>
            </header>
            <div class="item-bd">
              <ul class="section-content">
                <li>2023 年度「楚怡杯」湖南省职业院校技能竞赛（高职高专 WEB 应用软件开发）三等奖</li>
                <li>2023 年（第 19 届）湖南省大学生计算机程序设计竞赛应用开发竞赛三等奖</li>
                <li>第十四届蓝桥杯软件类省赛 Web 应用开发职业院校组二等奖</li>
                <li>第十三届蓝桥杯全国软件和信息技术专业人才大赛湖南赛区 C/C++ 程序设计大学 C 组三等奖</li>
                <li>2023 RoboCom 机器人开发者大赛 CAIP 编程设计赛道湖南省赛二等奖（晋级国赛）</li>
                <li>2022 RoboCom 机器人开发者大赛 CAIP 编程设计赛道湖南省赛三等奖</li>
                <li>2022 年第五届大学生计算机技能应用大赛（Java 科目）初赛专科组二等奖、决赛三等奖</li>
                <li>2023 年「厚浦杯」商业网页设计大赛大二组一等奖</li>
                <li>校内创新创业大赛一等奖；三好学生、文明学生、优秀学员</li>
                <li>国家励志奖学金，多次获得一等奖学金</li>
                <li>全国计算机一级证书；普通话二级（二乙）</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
  data() {
    return {
      BoxList: [
        { class: false, imgUrl: require('../../assets/add-circle.png') },
        { class: false, imgUrl: require('../../assets/add-circle.png') },
        { class: false, imgUrl: require('../../assets/add-circle.png') },
        { class: false, imgUrl: require('../../assets/add-circle.png') },
        { class: false, imgUrl: require('../../assets/add-circle.png') },
        { class: false, imgUrl: require('../../assets/add-circle.png') }
      ],
      ClassLayout: ''
    }
  },
  watch: {
    '$store.state.changeLayoutClass': {
      handler(newVal) {
        this.ClassLayout = newVal ? 'HLayout' : ''
      }
    }
  },
  methods: {
    showBox(flag) {
      const item = this.BoxList[flag]
      item.class = !item.class
      item.imgUrl = item.class
        ? require('../../assets/minus-circle.png')
        : require('../../assets/add-circle.png')
    },

    /* 折叠 / 展开的高度过渡 */
    foldEnter(el) {
      el.style.height = '0px'
      el.style.opacity = '0'
      // 触发重排，保证 0 → 实际高度 有过渡起点
      void el.offsetHeight
      el.style.height = el.scrollHeight + 'px'
      el.style.opacity = '1'
    },
    foldAfterEnter(el) {
      el.style.height = ''
      el.style.opacity = ''
    },
    foldLeave(el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.opacity = '1'
      void el.offsetHeight
      el.style.height = '0px'
      el.style.opacity = '0'
    },
    foldAfterLeave(el) {
      el.style.height = ''
      el.style.opacity = ''
    }
  }
}
</script>

<style lang="less" scoped>
.HLayout {
  flex-direction: column !important;

  .content-left {
    border-right: none;
    padding-right: 0;
  }

  .content-right {
    padding-left: 0;
    margin-top: 6px;
  }

  .section-hd {
    height: auto;
  }

  .section-title {
    font-size: 17px;
  }
}
</style>
